import { BottomSheetIllustrationContent } from "@src/appV2/redesign/system/ui-components";

interface DocumentSubmissionInReviewBottomSheetContentProps {
  title?: string;
  description?: string;
}

export function DocumentSubmissionInReviewBottomSheetContent(
  props: DocumentSubmissionInReviewBottomSheetContentProps
) {
  const {
    title = "Document is in review",
    description = "We've received the document you've submitted and will review it shortly",
  } = props;

  return (
    <BottomSheetIllustrationContent
      illustrationType="document-review"
      title={title}
      description={description}
    />
  );
}
